export const SET_SOLVES = 'SET_SOLVES';
export const SET_SOLVE = 'SET_SOLVE';
export const ADD_SOLVE = 'ADD_SOLVE';
export const ADD_SOLVES = 'ADD_SOLVES';
export const UPDATE_SOLVE = 'UPDATE_SOLVE';
export const REMOVE_SOLVE = 'REMOVE_SOLVE';
export const CLEAR_SOLVE = 'CLEAR_SOLVE';
export const CLEAR_SOLVES = 'CLEAR_SOLVES';
